export const ActionTypes = {
   getPages: 'seo/GET_PAGES',
   editPages: 'seo/EDIT_PAGES'
}
